export const layoutVariationMap = {
    'simple-3col': {
    label: 'Simple 3 Column',
    layoutType: '3COL',
    variation: 'simple',
    cardWrapping: false,
    includePreview: false,
    ui: {
      tabs: false,
      stepper: false
    },
    pagelayout:[]

  },
   'dashboard-3col': {
    isDashboard:true,
    label: 'Dashboard 3 column',
    layoutType: '3',
    variation: 'flow',
    cardWrapping: false,
    includePreview: false,
    ui: {
      tabs: false,
      stepper: false
    },
    pagelayout:[]

  } ,
  'simple-2col': {
    label: 'Simple 2 Column',
    layoutType: '2COL',
    variation: 'simple',
    cardWrapping: false,
    includePreview: false,
    ui: {
      tabs: false,
      stepper: false
    },
    pagelayout:[]

  },

  'simple': {
    label: 'Simple Auto',
    layoutType: 'AUTO',
    variation: 'simple',
    cardWrapping: false,
    includePreview: false,
    ui: {
      tabs: false,
      stepper: false
    },
    pagelayout:[]

  },
  'card-simple': {
    label: 'Card Simple',
    layoutType: 'AUTO',
    variation: 'card-simple',
    cardWrapping: true,
    includePreview: false,
    ui: {
      tabs: false,
      stepper: false
    },
    pagelayout:[]
  },
  'tabs-horizontal': {
    label: 'Tabs (Horizontal)',
    layoutType: '2COL',
    variation: 'tabs',
    cardWrapping: true,
    includePreview: false,
    ui: {
      tabs: true,
      orientation: 'horizontal'
    },
    pagelayout:[]
  },
  'tabs-horizontal-3column': {
    label: 'Tabs (Horizontal) 3 columns',
    layoutType: '3COL',
    variation: 'tabs',
    cardWrapping: true,
    includePreview: false,
    ui: {
      tabs: true,
      orientation: 'horizontal'
    },
    pagelayout:[]
  },
  'tabs-vertical': {
    label: 'Tabs (Vertical)',
    layoutType: '2COL',
    variation: 'tabs',
    cardWrapping: true,
    includePreview: false,
    ui: {
      tabs: true,
      orientation: 'vertical'
    },
    pagelayout:[]
  },
   'tabs-vertical-3column': {
    label: 'Tabs (Vertical) 3 columns',
    layoutType: '3COL',
    variation: 'tabs',
    cardWrapping: true,
    includePreview: false,
    ui: {
      tabs: true,
      orientation: 'vertical'
    },
    pagelayout:[]
  },
  'stepper-horizontal-top': {
    label: 'Stepper (Horizontal-Top)',
    layoutType: '2COL',
    variation: 'stepper',
    cardWrapping: true,
    includePreview: true,
    ui: {
      stepper: true,
      direction: 'Horizontal-Top'
    },
    pagelayout:[]
  },
    'stepper-horizontal-top-3column': {
    label: 'Stepper (Horizontal-Top) 3 Column',
    layoutType: '3COL',
    variation: 'stepper',
    cardWrapping: true,
    includePreview: true,
    ui: {
      stepper: true,
      direction: 'Horizontal-Top'
    },
    pagelayout:[]
  },
  'stepper-vertical': {
    label: 'Stepper (Vertical)',
    layoutType: '2COL',
    variation: 'stepper',
    cardWrapping: true,
    includePreview: true,
    ui: {
      stepper: true,
      direction: 'Vertical-Left'
    },
    pagelayout:[]
  },
  'stepper-vertical-3column': {
    label: 'Stepper (Vertical) 3 Columns',
    layoutType: '3COL',
    variation: 'stepper',
    cardWrapping: true,
    includePreview: true,
    ui: {
      stepper: true,
      direction: 'Vertical-Left'
    },
    pagelayout:[]
  },
};


export const bentoVariations = {
  'bento-3col': {
    label: 'Bento 3 column',
    layoutType: 'bento',
    variation: 'bento',
    presets: [
      [[4, 4,4] , [3,5,4] , [6,3,3] , [6,6]],
      [[3, 4,5] , [3,4,5] , [3,3,6] , [6,6]],
      [[6,6]], [4, 4,4] , [4,8] , [3,3,6] ,
      [[6,6]], [4,8] , [4,3,5] , [8,4] ,
      [[8, 4], [4, 8], [6,6] ,[5,7]],
      [[3, 9], [6, 6], [12] , [6,3,3]],
       [[6, 6] , [3,4,5] , [4,8] , [3,4,5]],
    ]
  }
};